import * as React from "react";
import {Icon} from "./Icon";

export class SearchIcon extends Icon {

  render() {
    return <Icon {...this.props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <path d="M40.12,37.88l-9.46-9.46A15,15,0,1,0,26,32.26l9.87,9.87a3,3,0,0,0,4.24-4.24ZM10,19a9,9,0,1,1,9,9A9,9,0,0,1,10,19Z" />
      </svg>
    </Icon>;
  }
}
